/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-no-bind */
import {ConfigProvider, App as AntdApp, message} from 'antd';
import {StyleProvider} from '@ant-design/cssinjs';
import VConsole from 'vconsole';
import zhCN from 'antd/lib/locale/zh_CN';
import enUS from 'antd/lib/locale/en_US';
import {Cookies} from 'react-cookie';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import utc from 'dayjs/plugin/utc';
import RouterIndex from '@/links/route';
import {initI18n} from '@/utils/i18n';
import {isLoadByIframe, isSandbox} from '@/utils/util';
import {useFramework} from '@/entries/share';
import EscapeAntd from '@/utils/escapeAntd';

dayjs.locale('zh-cn');
dayjs.extend(utc);

function initVConsole() {
    if (isSandbox() && !isLoadByIframe()) {
        return new VConsole();
    }
}

export const cookies = new Cookies();

const App = () => {
    const framework = useFramework();
    initI18n(framework);
    initVConsole();
    const locale = framework?.locale === 'en-us' ? enUS : zhCN;

    isLoadByIframe() && message.config({
        top: 200,
    });

    return (
        <ConfigProvider
            locale={locale}
            theme={{
                token: {
                    colorPrimary: '#2468F2',
                    borderRadius: 4,
                },
            }}
        >
            <StyleProvider>
                <AntdApp>
                    <EscapeAntd />
                    <RouterIndex />
                </AntdApp>
            </StyleProvider>
        </ConfigProvider>
    );
};

export default App;
